import { http } from '../helpers/axiosHelper';
export default class ModuleService {
   async createModule(body: any) {
      // 'module_type_id'     => 'numeric|min:0|required',
      // 'page_sequence'      => 'numeric|min:0|required',
      // 'sequence'           => 'numeric|min:0|required',
      //  'page_sequence'     => 'numeric|min:0',
      // 'sequence'           => 'numeric|min:0',
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module', body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon module niet aanmaken`);
            }
         })
         .catch((error) => {
            throw Error(`Kon module niet aanmaken`);
         });
   }

   async getModule(moduleId: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + moduleId)
         .then((response) => {
            if (response.data && response.status) {
               return response.data;
            } else {
               throw Error(`Kon module niet ophalen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon module niet ophalen`);
         });
   }

   async getPossibleModuleAttributes(moduleId: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + moduleId + '/possible-module-attributes')
         .then((response) => {
            if (response.data && response.status) {
               return response.data;
            } else {
               throw Error(`Kon mogelijke module attributen niet ophalen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon mogelijke module attributen niet ophalen`);
         });
   }

   async updateModule(body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + body.id, body).then((response) => {
         return response.data;
      });
   }

   async patchModule(moduleId: Number, body: any) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + moduleId, body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon module niet wijzigen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon module niet wijzigen`);
         });
   }

   async deleteModule(id: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + id);
   }

   async resetModule(id: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + id + '/reset').then((response) => {
         return response.data;
      });
   }

   async duplicateModule(id: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + id + '/duplicate', {
            params: {
               include: 'module_type,choices,texts,property.texts,media,moduleAttributes.attributable',
            },
         })
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            return error.response.status;
         });
   }

   async editPageSequence(pageSequence: Object, id: Number) {
      return await http.patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/' + id, [
         {
            op: 'replace',
            path: 'page_sequence',
            value: pageSequence,
         },
      ]);
   }

   async copyModuleAttributes(moduleId: Number, originLanguageId: Number, targetLanguageId: Number) {
      return await http
         .post(
            import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module/copyAttributes',
            {
               module_id: moduleId,
               origin_language_id: originLanguageId,
               target_language_id: targetLanguageId,
            },
            { params: { include: 'module_attributes,module_attributes.module_attribute_appearances,module_attributes.attributable' } }
         )
         .then((response) => {
            return response.data;
         });
   }
}
